import {Box} from "@mui/system";

const BlockEditOverlay = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "-15px",
        left: "-10px",
        right: "-10px",
        bottom: "-10px",
        backgroundColor: "rgba(0, 0, 0, 0.3)", // Preto com 30% de opacidade
        zIndex: 1,
        pointerEvents: "auto", // Bloqueia interações
        cursor: "not-allowed", // Indica que está bloqueado
      }}
      onClick={(e) => {
        // Previne qualquer interação
        e.stopPropagation();
        e.preventDefault();
      }}
    />
  );
};

export default BlockEditOverlay;
